import React, { Component } from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  InputGroup,
  Input,
  InputGroupAddon,
  InputGroupText,
  Button
} from "reactstrap";
import PlaylistService from "../../services/playlistService";
import { Redirect } from "react-router";
import { CompanyService } from "../../services/companyService";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import {Link} from "react-router-dom";

let playlistService = new PlaylistService();
let companyService = new CompanyService();

class EditPlaylistConnector extends Component {
  constructor(props) {
    super(props);
    let creating;
    if (this.props.match.params.hasOwnProperty("id")) creating = false;
    else creating = true;
    this.state = {
      name: "",
      path: "",
      type: "",
      success: false,
      typeList: [{id:'spot',name:'Publicidad'},{id:'music',name:'Música'}],
      creating: creating
    };
    companyService.reload();
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    if (!creating) this.loadData();
  }
  handleChange(event) {
    this.setState({ [event.target.id]: event.target.value });
  }
  handleSubmit(event) {

    this.render();

    event.preventDefault();
    let self = this;
    const {
      name,
      path,
      type
    } = this.state;
    let req = {
      name: name,
      path: path,
      type: type
    };
    playlistService
      .createOrEdit(req, this.props.match.params.id)
      .then(function(data) {
        if (!data.hasOwnProperty("error")) {
          self.setState({
            success: true
          });
          self.context.getNotificationSystem().addNotification({
            message:
              "Se ha " +
              (self.state.creating ? "creado" : "editado") +
              " exitosamente una Playlist.",
            level: "success"
          });
        }
      })
      .catch(function(error) {
        console.log(error);
      });
  }
  loadData() {
    let self = this;
    playlistService
      .readByID(this.props.match.params.id)
      .then(function(data) {
        if (!data.hasOwnProperty("error")) {
          data.loading = false;
          self.setState(data);
        }
      })
      .catch(function(error) {
        console.log(error);
      });
  }

  sendMessage(){
    this.context.getNotificationSystem().addNotification({
      message:
        "Guardando datos, por favor espere.",
      title: this.state.creating
        ? "Creación"
        : "Edición",
      level: "info"
    });
  }
  render() {
    const {
      creating,
      name,
      path,
      type,
      loading,
      success
    } = this.state;
    if (success) return <Redirect to="/playlists" push={true} />;
    return (
      <div className="animated fadeIn">
        <Row>
          <Col xs="12" sm="12" lg="12">
            <Card>
              <CardHeader>
                <Row>
                  <Col sm="5">
                    <CardTitle className="mb-0">
                      {creating ? "Agregando Playlist" : "Editando Playlist"}
                    </CardTitle>
                    <div className="small text-muted">{name}</div>
                  </Col>
                  <Col sm="7" className="d-sm-inline-block" />
                </Row>
              </CardHeader>
              <CardBody>
                <form onSubmit={this.handleSubmit}>
                  <Row>
                    <Col>
                      <InputGroup className="mb-3">
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>Nombre</InputGroupText>
                        </InputGroupAddon>
                        <Input
                          required
                          type="text"
                          disabled={loading}
                          id="name"
                          value={name}
                          onChange={this.handleChange}
                        />
                      </InputGroup>
                      <InputGroup className="mb-3">
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>Tipo</InputGroupText>
                        </InputGroupAddon>
                        <Input
                          required
                          type="select"
                          id="type"
                          value={type}
                          onChange={this.handleChange}
                        >
                          <option value="">Selecciona un tipo de medio</option>
                          {this.state.typeList.map((e, i) => {
                            return (
                              <option key={i} value={e.id}>
                                {e.name}
                              </option>
                            );
                          })}
                        </Input>
                      </InputGroup>
                      <InputGroup className="mb-3">
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>Path S3</InputGroupText>
                        </InputGroupAddon>
                        <Input
                          required
                          type="text"
                          disabled={loading}
                          id="path"
                          value={path}
                          onChange={this.handleChange}
                        />
                      </InputGroup>

                      <div className="float-right">
                        <Link
                            to={"/playlists/"}
                            className="btn btn-danger"
                          >
                            Cancelar
                          </Link>


                        <span> </span>
                        <Button color="success">
                          {creating ? "Agregar" : "Guardar"}
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}

EditPlaylistConnector.contextTypes = {
  getNotificationSystem: PropTypes.func.isRequired
};

const mapStateToProps = state => {
  return {
    playlists: state.playlists,
    user: state.user
  };
};

const EditPlaylist = connect(
  mapStateToProps,
  null
)(EditPlaylistConnector);

export default EditPlaylist;
